import styled from "styled-components";
import { COLORS, fontMixins } from "../../styles";

export const OP_Container = styled.div`
	display: flex;
	background: ${COLORS.White};
	padding: 59px 0 45px 56px;
	border-radius: 11px;
	column-gap: 30px;
`;

export const OR_LeftBlock = styled.div`
	display: flex;
	column-gap: 15px;
	padding-right: 60px;
	border-right: 1px solid #c2c8ce;
`;

export const OR_RightBlock = styled.div`
	padding-top: 5px;
	padding-bottom: 10px;
	display: flex;
	flex: 1;
	flex-direction: column;
	row-gap: 20px;
`;

export const OR_TextBlock = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 8px;
`;

export const OR_Title = styled.div`
	${fontMixins(34, 700)};
`;

export const OR_Description = styled.div`
	${fontMixins(14, 400)}
	color: #919191;
`;

export const OR_Icon = styled.div`
	display: flex;
`;

export const OR_BlockText = styled.div`
	display: flex;
	${fontMixins(14, 400)};
	color: #191919;
	line-height: 20px;
`;
